/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Spinner } from '../../../AbstractElements';
import Grow from '@mui/material/Grow';
import { getGuestsMovementsFn } from '../../../api/api';
import GuestsMovemetsTable from './GuestsMovemetsTable';
import AddGuestMovements from './AddGuestMovements';
// import ProcessMovements from './ProcessMovements';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}

const GuestsMovements = () => {
  const { basictoaster, loading, setLoading, guestsMovements, setGuestsMovements } = useStateContext();

  useEffect(() => {
    // set ab to state and use this new ab in this code
    let newAbortController = new AbortController()
    setLoading(true);
    getGuestsMovementsFn('always', newAbortController.signal).then((resp) => {
      if (!newAbortController.signal.aborted) {
        setGuestsMovements(resp);
        setLoading(false);
      }
    }).catch((err) => {basictoaster("error", "Errore movimenti ospiti", err, () => {})});
    
    // Cleanup function to abort the request when the component unmounts
    return () => {
      newAbortController.abort();
    };
  }, [])

  // ALERT
  useEffect(() => {
    if (isObject(guestsMovements) && containsError(guestsMovements)) {
      basictoaster("error", "Errore movimenti ospiti", guestsMovements.Error, setGuestsMovements)
    }
  }, [guestsMovements])

  return (
    <Fragment>
    <br />
      <Breadcrumbs phish mainTitle="Movimento ospiti" parent="DomusVestra" title="Movimento ospiti" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                {/* <NewReq /><br /><br /> */}
                {loading ? (
                  <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-1' }} />
                  </div>
                ) : (
                  <>
                    <h2><b>Movimento ospiti</b></h2><br />
                    <AddGuestMovements /><br /><br />
                    {/* <ProcessMovements /><br /><br /> */}
                    <GuestsMovemetsTable />
                  </>
                )}
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GuestsMovements;